



import Page from '../attendance/attendances/personholiday.vue'
export default {
  name: 'attendanceRecord',
  components: { Page },
}
